import TextareaAutosize from 'react-textarea-autosize';
import { BottomSheet, Button, Confirm, Typography } from '@/ui-kit';
import styles from './form-message.module.scss';
import { ActivatedProfileIcon2, BannedUserIcon, BlockedIcon, CheckIcon, ClockIcon, CloseOutlinedIcon, DisabledCheckIcon, ErrorNotificationIcon, HiddenProfileIcon, OkHandIcon, TelegramDisabledIcon, TelegramIcon, VerificationIcon, VerifiedAccountIcon } from '@/assets/icons';
import React, { useEffect, useState } from 'react';
import { EDIT_MODE, EDITING_FINISHED, REPLY_FINISHED, REPLY_MODE, useChat, } from '@/store/useChat';
import { Profile } from '@/types/profile';
import { useAuth } from '@/store/useAuth';
import WebApp from '@twa-dev/sdk';
import { useVerification } from '@/store/useVerification';
import { useActionCableCreate } from '@/hooks/use-action-cable';
import { SocketPayload } from '@/types/socket-payload';
import { jwtService } from '@/services/jwt.service';
import { useVibration } from '@/store/useVibration';
import { useClearChatWhithUser } from '@/hooks/use-clear-chat-whith-user';
import { routesApp } from '@/constans/routes';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { profilesApi } from '@/api';
import { useToast } from '@/store/useToast';
import { VerificationBottomsheet } from '@/components/verification-bottomsheet';
import { ru } from 'date-fns/locale';
import { differenceInDays, differenceInHours, format, formatDistance, parse } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useLogProfileChannelRejection } from '@/hooks/use-log-profile-channel-rejection';

interface Props {
    profileChat: Profile | undefined,
    chatId: number;
    isLoadingChat?: boolean,
    isErrorChat?: boolean,
    expiredAt?: string | null,
    onReply?: (data: {
        reply_message_id: number | string
        message: string
    }) => void;
    onEdit?: (data: {
        message_id: number | string
        message: string,
    }) => void;
    onSend?: (data: any) => void;
    onFocus: () => void;
    onBlur: () => void;
    refetchMessages: () => void;
    onChange?: (e: string) => void;
    onSubmit?: () => void;
    onChatModeClear?: () => void;
}
export const FormMessage: React.FC<Props> = ({
    profileChat,
    chatId,
    isLoadingChat,
    isErrorChat,
    expiredAt,
    onReply,
    onEdit,
    onSend,
    onFocus,
    onBlur,
    refetchMessages,
    onChange,
    onSubmit,
    onChatModeClear,
}) => {
    const msg = useChat((state) => state.msg);
    const setMsg = useChat((state) => state.setMsg);
    const contextMsg = useChat((state) => state.contextMsg);
    const clearContextMsg = useChat((state) => state.clearContextMsg);
    const chatMode = useChat((state) => state.chatMode);
    const setChatMode = useChat((state) => state.setChatMode);
    const setStatus = useChat((state) => state.setStatus);
    const clearMenu = useChat((state) => state.clearMenu);
    const setContextMsg = useChat((state) => state.setContextMsg);
    const userData = useAuth((state) => state.getUser());
    const setProfile = useAuth((state) => state.setProfile);
    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);

    const { isVibrationEnabled } =
        useVibration(state => state);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        onSubmit?.()
        handleSend();
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const isEditMode = chatMode === EDIT_MODE
    const isReplyMode = chatMode === REPLY_MODE

    const handleSend = () => {
        if (!msg) return;

        if (isEditMode) {
            const editedMsgId = contextMsg?.id
            if (editedMsgId)
                onEdit?.({
                    message_id: editedMsgId,
                    message: msg
                });
            setStatus(EDITING_FINISHED)
        } else if (isReplyMode) {
            const replyMsgId = contextMsg?.id
            if (replyMsgId)
                onReply?.({
                    reply_message_id: replyMsgId,
                    message: msg
                });
            setStatus(REPLY_FINISHED)
        } else
            onSend?.({
                message: msg, // Optional
            });

        setMsg('');
        
        // reset chat mode
        setChatMode(null);
        onChatModeClear?.();

        clearMenu();
    };

    const handleBlur = () => {
        // setTimeout(() => {
        //     window.scrollTo({ top: 0, behavior: 'smooth' });
        // }, 800);
    };

    const onFocusHandle = () => {
        onFocus();
        handleBlur();
    };

    const onBlurHandle = () => {
        onBlur();
        handleBlur();
    };

    const { hasPendingVerificationError, setHasPendingVerificationError } = useVerification((state) => state);

    const CHANEL_NAME = 'ProfileChannel';
    let chanel: any;
    const isDev = process.env.NODE_ENV === 'development';
    const getPathFromWebSocketUrlIsDev = (url: string) => {
        if (isDev) {
            // const parsedUrl = new URL(url);
            // return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
            // TODO: url to env
            return 'http://localhost:8255/cable';
            // return 'http://localhost:3300/cable';
        }
        return url;
    };
    const cable = useActionCableCreate(
        getPathFromWebSocketUrlIsDev('/cable')
    );

    const { logProfileChannelRejection } = useLogProfileChannelRejection()
    
    useEffect(() => {
        chanel = cable.subscriptions.create(
            {
                channel: CHANEL_NAME,
                authentication: WebApp.initData.length ? WebApp.initData : jwtService.getAccessToken(),
            },
            {
                connected() {
                    console.log('conented');
                },
                received(payload: SocketPayload) {
                    console.log('received', payload);
                    switch (payload.type) {
                        case 'profile_verified':
                            setIsVerificationModalOpen(false)
                            setProfile({ ...userData, verification_status: 'verified' })
                            setHasPendingVerificationError(false)
                            break;
                    }
                },
                disconnected() {
                    console.log('WebSocket отключён. Пытаемся переподключиться...');
                },
                rejected() {
                    console.log('Сервер отклонил подписку!');
                    logProfileChannelRejection({ channel: CHANEL_NAME })
                },
            },
        );
        return () => {
            cable.subscriptions.remove(chanel);
        };
    }, []);

    const [isOpenConfirm, setIsOpenConfirm] = useState(false);
    const handleConfirm = async () => {
        if (!profileChat)
            return
        try {
            await clearChatWithUserAction(profileChat.id);
            setIsOpenConfirm(false);
        } catch (error) {
            console.error(error);
        }
    };

    const { mutateAsync: clearChatById, isPending: isLoadingClearChat } = useClearChatWhithUser(chatId);
    
    const { messages, setMessages } = useChat(state => state);

    const clearChatWithUserAction = async (profileId: number | '') => {
        await clearChatById(profileId);
        refetchMessages?.();
        setMessages((_) => [])
    };

    const showToast =
        useToast((state) => state.show);

    const onActivateAccountClick = async () => {
        callYaMetrika('return_to_search');
        try {
            await profilesApi.activate();
            showToast({
                icon: (
                    <ActivatedProfileIcon2 />
                ),
                msg: t('you_are_searching_again')
            })
            setProfile({
                ...userData,
                active: true,
            });
        } catch (e) {
            showToast({
                icon: <ErrorNotificationIcon />,
                msg: t('error_try_again')
            })
        }
    }

    const clockIconSize = 19.2
    const { t, i18n } = useTranslation();
    const rtf = new Intl.RelativeTimeFormat(i18n.language, { style: 'long' });

    return (
        <div
            id="chat-send-form"
            className={styles.wrapper}>
            {
                isEditMode ?
                    <div className={styles.editMsgHeaderWrap}>
                        <div className={styles.editMsgHeader}>
                            <div className={styles.editMsgHeaderMain}>
                                <span className={styles.editMsgHeaderMainTitle}>
                                    {t('msgs.editting')}
                                </span>
                                <span className={styles.editMsgHeaderMainSubtitle}>
                                    {contextMsg?.content}
                                </span>
                            </div>
                            <Button
                                className={styles.editMsgHeaderCloseBtn}
                                onClick={() => {
                                    setChatMode(null)
                                    setMsg('')
                                    setContextMsg(null)
                                    onChatModeClear?.()
                                }}>
                                <CloseOutlinedIcon />
                            </Button>
                        </div>
                    </div>
                : isReplyMode ?
                    <div className={styles.editMsgHeaderWrap}>
                        <div className={styles.editMsgHeader}>
                            <div className={styles.editMsgHeaderMain}>
                                <span className={styles.editMsgHeaderMainTitle}>
                                    {t('msgs.your_answer', { name: profileChat?.public_name })}
                                </span>
                                <span className={styles.editMsgHeaderMainSubtitle}>
                                    {contextMsg?.content}
                                </span>
                            </div>
                            <Button
                                className={styles.editMsgHeaderCloseBtn}
                                onClick={() => {
                                    setChatMode(null)
                                    setMsg('')
                                    clearMenu()
                                    clearContextMsg()
                                    onChatModeClear?.()
                                }}>
                                <CloseOutlinedIcon />
                            </Button>
                        </div>
                    </div>
                : <></>
            }
            {
                (
                    !isLoadingChat &&
                    !isErrorChat &&
                    expiredAt &&
                    !messages.length
                ) &&
                <div className={styles.matchWillDeleted}>
                    <ClockIcon
                        className={styles.matchWillDeletedIcon}
                        width={clockIconSize}
                        height={clockIconSize} />
                    <p className={styles.matchWillDeletedTitle}>
                        {
                            differenceInDays(expiredAt, new Date()) > 0 ?
                                t('msgs.expired_match_relative', { relative: rtf.format(differenceInDays(expiredAt, new Date()), 'day') })
                            : differenceInHours(expiredAt, new Date()) > 0 ?
                                t('msgs.expired_match_relative', { relative: rtf.format(differenceInHours(expiredAt, new Date()), 'hour') })
                            :
                                t('msgs.expired_match')
                        }
                    </p>
                </div>
            }
            {
                profileChat
                    ?.moderation_status
                    === 'banned' ?
                    <div className={styles.bannedBlock}>
                        <div className={styles.bannedBlockContent}>
                            <BannedUserIcon className={styles.bannedBlockContentIcon} width={24} height={24} />
                            <div className={styles.bannedBlockContentInfo}>
                                <Typography
                                    variant="h6"
                                    fontFamily="SFProText"
                                    fontWeight="semibold">
                                    {t('account_banned')}
                                </Typography>
                                <Typography variant="p" fontFamily="SFProText">
                                    {t('banned_subtitle')}
                                </Typography>
                            </div>
                        </div>
                        <Button
                            textColor={'black'}
                            className={styles.verificationMsgBtn}
                            onClick={() => setIsOpenConfirm(true)}>
                            <Typography
                                variant="p"
                                fontFamily="SFProText"
                                fontWeight="semibold">
                                {t('msgs.clear_chat')}
                            </Typography>
                        </Button>
                    </div>
                : !profileChat?.active || !userData?.active ?
                    <div className={styles.bannedBlock}>
                        <div className={styles.bannedBlockContent}>
                            <HiddenProfileIcon
                                width={24}
                                height={23.53}
                                className={styles.bannedBlockContentIcon} />
                            <div className={styles.bannedBlockContentInfo}>
                                <Typography
                                    variant="h6"
                                    fontFamily="SFProText"
                                    fontWeight="semibold">
                                    {
                                        !userData?.active ?
                                            t('msgs.your_profile_is_hidden')
                                        :
                                            t('msgs.account_deactivated')
                                    }
                                </Typography>
                                <Typography variant="p" fontFamily="SFProText">
                                    {t('msgs.dialog_note')}
                                </Typography>
                            </div>
                        </div>
                        {
                            !userData?.active &&
                            <Button
                                textColor={'black'}
                                className={styles.verificationMsgBtn}
                                onClick={onActivateAccountClick}>
                                <Typography
                                    variant="p"
                                    fontFamily="SFProText"
                                    fontWeight="semibold">
                                    {t('activate_profile')}
                                </Typography>
                            </Button>
                        }
                    </div>
                : userData
                    ?.verification_status
                    === 'pending' ||
                userData
                    ?.verification_status
                    === 'rejected' ||
                hasPendingVerificationError ?
                    <div className={styles.verificationMsg}>
                        <div className={styles.verificationMsgInfo}>
                            <div className={styles.verificationMsgInfoHeader}>
                                <Typography
                                    variant="h6"
                                    fontFamily="SFProText"
                                    fontWeight="semibold">
                                    Euphora
                                </Typography>
                                <VerifiedAccountIcon />
                            </div>
                            <div className={styles.verificationMsgInfoSubtitle}>
                                <Typography variant="p" fontFamily="SFProText">
                                    {t('msgs.chat_verification_msg')}
                                </Typography>
                            </div>
                        </div>
                        <Button
                            textColor={'black'}
                            className={styles.verificationMsgBtn}
                            onClick={() => setIsVerificationModalOpen(true)}>
                            <Typography
                                variant="p"
                                fontFamily="SFProText"
                                fontWeight="semibold">
                                {t('start_verification')}
                            </Typography>
                        </Button>
                    </div>
                :
                    <form
                        onSubmit={handleSubmit}
                        className={styles.formMessage}>
                        <TextareaAutosize
                            minRows={1}
                            maxRows={4}
                            className={styles.textarea}
                            placeholder={t('msgs.msg')}
                            value={msg}
                            onChange={(e) => {
                                setMsg(e.target.value)
                                onChange?.(e.target.value)

                            }}
                            onFocus={onFocusHandle}
                            onBlur={onBlurHandle} />
                        <Button
                            type="submit"
                            className={styles.button}
                            disabled={!msg.length}>
                            {
                                msg.length ?
                                    (
                                        chatMode === 'edit' ?
                                            <CheckIcon
                                                width={24}
                                                height={24} />
                                        :
                                            <TelegramIcon
                                                width={24}
                                                height={24} />
                                    )
                                :
                                    (
                                        chatMode === 'edit' ?
                                            <DisabledCheckIcon
                                                width={24}
                                                height={24} />
                                            :
                                            <TelegramDisabledIcon
                                                width={24}
                                                height={24} />
                                    )
                            }
                        </Button>
                    </form>
            }
            <VerificationBottomsheet isVerificationModalOpen={isVerificationModalOpen} setIsVerificationModalOpen={setIsVerificationModalOpen} />
            <Confirm
                isOpen={isOpenConfirm}
                onClose={() => setIsOpenConfirm(false)}
                title={t('msgs.confirm_clear_chat_title')}
                text={t('msgs.confirm_clear_chat_desc')}
                onConfirm={handleConfirm}
                buttonTextSubmit={t('msgs.accept')}
                isLoading={isLoadingClearChat} />
        </div>
    );
};
